module.exports = __webpack_public_path__ + "static/floating-action-button-action-modify-dont-0466b16b606ffc69bf043cb1d68cb890.png";